import React from 'react';
import PropTypes from 'prop-types';
import { logger } from 'packages';

class ApplicationErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error) {
        this.setState({ hasError: true });
        logger(error);
    }

    render() {
        const { hasError } = this.state;
        const { children, fallback } = this.props;

        if (hasError) {
            return fallback ? fallback : null;
        }
        return children;
    }
}

ApplicationErrorBoundary.propTypes = {
    fallback: PropTypes.node
};

export default ApplicationErrorBoundary;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/error/application-error-boundary.jsx